<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <transportation-form />
  </v-container>
</template>

<script>
import TransportationForm from './_Form'
export default {
  name: 'AdminMasterTransportationEdit',
  components: {
    TransportationForm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '運搬方法一覧', disabled: false, to: '/admin/masters/transportations', exact: true },
        { text: '運搬方法編集', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
